import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios"; // for future use

const LoginForm = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { email, password } = form;

    if (!email || !password) {
      setError("Both fields are required.");
      return;
    }

    setLoading(true);

    // TEMP: Hardcoded login logic
    if (email === "Abdul" && password === "Abdul@123") {
      localStorage.setItem("user", JSON.stringify({ name: "Abdul", email }));
      navigate("/app");
    } else {
      setError("Invalid email or password.");
    }

    setLoading(false);

    // FUTURE API (uncomment when ready)
    /*
    try {
      const res = await axios.post("http://localhost:5000/api/login", form);
      // Store token or user
      navigate("/app");
    } catch (err) {
      setError(err.response?.data?.message || "Login failed.");
    } finally {
      setLoading(false);
    }
    */
  };

  return (
    <div className="max-w-md mx-auto mt-20 p-6 border shadow-md rounded-lg bg-white">
      <h2 className="text-2xl font-bold mb-6 text-center">Login</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block mb-1">Email</label>
          <input
            type="text"
            name="email"
            value={form.email}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            placeholder="Enter email or username"
          />
        </div>
        <div className="mb-4">
          <label className="block mb-1">Password</label>
          <input
            type="password"
            name="password"
            value={form.password}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            placeholder="Enter password"
          />
        </div>
        {error && <p className="text-red-500 mb-3">{error}</p>}
        <button
          type="submit"
          className="w-full bg-blue-600 text-white p-2 rounded hover:bg-blue-700"
          disabled={loading}
        >
          {loading ? "Logging in..." : "Login"}
        </button>
      </form>
    </div>
  );
};

export default LoginForm;
